import React from 'react';
import {NavLink} from "react-router-dom";

const menuContainer = props => {
  return (
    <div id="menubar" className="menubar-inverse  animate">
      {/*<div className="menubar-fixed-panel">*/}
        {/*<div>*/}
          {/*<a className="btn btn-icon-toggle btn-default menubar-toggle" data-toggle="menubar"*/}
             {/*href="javascript:void(0);">*/}
            {/*<i className="fa fa-bars"></i>*/}
          {/*</a>*/}
        {/*</div>*/}
        {/*<div className="expanded">*/}
          {/*<a href="../../html/dashboards/dashboard.html">*/}
            {/*<span className="text-lg text-bold text-primary ">MATERIAL&nbsp;ADMIN</span>*/}
          {/*</a>*/}
        {/*</div>*/}
      {/*</div>*/}
      <div className="nano has-scrollbar">
        <div className="nano-content" tabIndex="0">
          <div className="menubar-scroll-panel">

            <ul id="main-menu" className="gui-controls">

              <li className="expanding">
                <NavLink to="/" exact>
                  <div className="gui-icon"><i className="md md-home"/></div>
                  <span className="title">Dashboard</span> 
                </NavLink>
                {/*<a href="../../html/dashboards/dashboard.html" className="active">*/}
                {/*<div className="gui-icon"><i className="md md-home"></i></div>*/}
                {/*<span className="title">Dashboard</span>*/}
                {/*</a>*/}
              </li>

              <li>
                <NavLink to='stats'>
                {/*<NavLink to={{
                  pathname: 'stats',
                  hash: '#world-map'
                }}>*/}
                  <div className="gui-icon"><i className="md md-assessment"/></div>
                  <span className="title">COVID-19 Stats</span>
                </NavLink>
              </li>
              <li>
                <NavLink to='pharmacies'>
                  <div className="gui-icon"><i className="fa fa-heartbeat"/></div>
                  <span className="title">Pharmacies</span>
                </NavLink>
              </li>
              <li>
                <NavLink to='groceries'>
                  <div className="gui-icon"><i className="fa fa-shopping-cart"/></div>
                  <span className="title">Groceries</span>
                </NavLink>
              </li>
            </ul>

            <div className="menubar-foot-panel">
              <small className="no-linebreak hidden-folded">
                {/*<span className="opacity-75">Copyright © 2020</span> <strong></strong>*/}
              </small>
            </div>
          </div>
        </div>
        <div className="nano-pane" style={{display: 'block'}}>
          <div className="nano-slider" style={{height: '317px', transform: 'translate(0px, 0px)'}}></div>
        </div>
      </div>

    </div>
  );
};

export default menuContainer;
